export const ORIENTATION_SHIFT_GREEN_COLOR = "#5EB174";
export const ORIENTATION_SHIFT_NAME = "ori";

/**
 * Extra horizontal room the redesign mini-calendar needs to fit a 4th
 * orientation dot. Added to the sidebar width when single-shift orientation
 * is enabled so the dot row doesn't overflow its container.
 */
export const ORIENTATION_DOT_EXTRA_WIDTH = "2.5rem";
